import { ArticleContent } from '@/components/layout/ArticleContent';

export const ShippingPage = () => {
  return (
    <ArticleContent>
      <h1>EternaLife Shipping</h1>
      <p>Last Updated: Martch 29 th, 2024</p>
      <ul>
        <li>Free Lithuania shipping on orders over €150</li>
        <li>Free Europe shipping on orders €200+</li>
        <li>Free shipping worldwide on orders €300+</li>
      </ul>
      <p>Orders placed after 12pm will process next working day</p>
      <p>
        For International shipping, any import duties, taxes, handling fees due
        at the time of delivery, are the sole responsibility of the customer
        receiving the order
      </p>
    </ArticleContent>
  );
};
